module.exports = __webpack_public_path__ + "static/media/puzzle-35-bg.8a7a724d.svg";